import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: {}
    },
    mutations: {
        getUserInfo(state,userIn){
            state.userInfo=userIn
        }
    },
    actions: {
       
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js